$(function() {
	jQuery(document).on( 'nfFormReady', function( e, layoutView ) {
		var formContainer = $('.nf-form-cont.travel_partners');
		if (!formContainer.length)
			return;
		var addGuestTrigger = formContainer.find('#add_guest');
		var guestCount = 2;

		addGuestTrigger.on("click", function(e){
			e.preventDefault();

			if(formContainer.find('.guest_' + guestCount).length){
				formContainer.find('.guest_' + guestCount).show();
				guestCount++;
			}

			if(!formContainer.find('.guest_' + guestCount).length){
				addGuestTrigger.hide();
			}
		});
	});
});
